import Layout from "../components/utils/layout";
import React from "react";

const FraudMonitoring = () => {
    const screenId="FraudMonitoring"
    const charts = {
        daily_fraud_monitoring_high_risk_new : {},
        daily_fraud_monitoring_high_risk_old : {},
        daily_fraud_monitoring_full_list : {},
        gifts_summary : {},
        gifts_list : {},
        heavy_loaders: {},
        high_loaders: {
            source:"live"
        },
        top_gifters: {
            source:"live"
        },
        fraud_monitoring_monthly_declines: {},
        fraud_monitoring_daily_declines: {},
        fraud_monitoring_crypto_wire: {},
        transaction_high_risk_countries: {},
        transaction_restricted_countries: {},
    }

    return <Layout prefsPrefix={screenId} items={charts}/>
}

export default FraudMonitoring
